"use strict";

var _slicedToArray = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _createForOfIteratorHelper = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invalidIdArray = exports.hebrewOnly = exports.fullNameHebrewOnly = exports.crcValidIsraeliId = void 0;
exports.isIsraeliIdValid = isIsraeliIdValid;
exports.validPhone = exports.validIsraeliId = void 0;
var yup = _interopRequireWildcard(require("yup"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
/* eslint-disable one-var */
/* eslint-disable one-var-declaration-per-line */
/* eslint-disable sort-vars */
/* eslint-disable no-extra-parens */

var mandatoryTitle = 'שדה חובה';
var invalidIdArray = exports.invalidIdArray = ['000000000'];
var hebrewOnly = exports.hebrewOnly = yup.string().matches(/^[\s\u0590-\u05fe]+$/, 'עברית בלבד').required(mandatoryTitle);
var fullNameHebrewOnly = exports.fullNameHebrewOnly = yup.string().test('fullNameHebrewOnly', 'שם מלא בעברית', function (value) {
  // value can be undefined and this will crash all validation
  var arrayFromInput = value ? value.split(' ') : [];
  if (arrayFromInput.includes('')) {
    return false;
  }
  if (arrayFromInput.length < 2) {
    return false;
  }
  var isEveryWordInHebrew = arrayFromInput.map(function (word) {
    return /^[\s\u0590-\u05fe]+$/.test(word);
  }).every(function (word) {
    return word === true;
  });
  return isEveryWordInHebrew;
}).required(mandatoryTitle);
function isIsraeliIdValid(id) {
  var strId = String(id).trim();

  /*
       if (strId.length > 9) {
           return false;
       }
       if (strId.length < 9) {
           while (strId.length < 9) strId = "0" + strId;
       }
        */
  if (strId.length !== 9 || invalidIdArray.includes(strId)) {
    return false;
  }
  var counter = 0,
    rawVal,
    actualVal;
  for (var i = 0; i < strId.length; i++) {
    rawVal = Number(strId[i]) * (i % 2 + 1);
    actualVal = rawVal > 9 ? rawVal - 9 : rawVal;
    counter += actualVal;
  }
  return counter % 10 === 0;
}
var validPhone = exports.validPhone = yup.string().length(10, 'יש להקליד עשר ספרות בלבד').matches(/^0\d{9}$/, 'מספר טלפון - ספרות בלבד').required(mandatoryTitle);
var validIsraeliId = exports.validIsraeliId = yup.string().required(mandatoryTitle).test('validation for israeli id', 'מספר תעודת זהות בלבד', function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return !value || isIsraeliIdValid(value);
});

// TODO: finish work, it still doesn't rellt verify CRC
var crcValidIsraeliId = exports.crcValidIsraeliId = yup.string().test('crcValidIsraeliId', 'מספר תעודת זהות בלבד', function (value) {
  var stringId = String(Number(value)).trim();
  console.log(stringId);
  if (stringId.length > 9) {
    return false;
  }
  if (stringId.length < 9) {
    while (stringId.length < 9) {
      stringId = '0' + stringId;
    }
  }
  var actualValue;
  var counter = 0;
  var rawValue;
  var _iterator = _createForOfIteratorHelper(stringId.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        i = _step$value[0],
        element = _step$value[1];
      rawValue = Number(element) * (i % 2 + 1);
      actualValue = rawValue > 9 ? rawValue - 9 : rawValue;
      counter += actualValue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return counter % 10 === 0;
}).required(mandatoryTitle);